import { Injectable } from '@angular/core';
import * as _ from 'lodash';

export interface TableKeyData { [key: string]: string; }

@Injectable()
export class SessionStorageService {
  public static CURRENT_WORKLIST_DYNAMIC_SEARCH: string = 'currentWorkListDynamicSearch';
  public static WORKLIST_SESSION_STORAGE_NAME: string = 'tableState';
  public static PREV_DASHBOARD_URL: string = 'prevDashboardURL';

  getAssociationItemsFromCurrentWorkList(names: string[]): { } {
    const result = { };
    const workListDynamicSearch = JSON.parse(sessionStorage.getItem(SessionStorageService.CURRENT_WORKLIST_DYNAMIC_SEARCH));

    if (!_.isEmpty(workListDynamicSearch)) {
      const associationItems: [] = _.get(workListDynamicSearch, 'associationItems', []);

      names.forEach(name => {
        result[name] = associationItems.find((item: { name: string }) => item.name === name);
      });
    }

    return result;
  }

  getTableKeyDataFromCurrentWorkList(item: Object, names: string[]): TableKeyData {
    const result = { };
    const data = this.getAssociationItemsFromCurrentWorkList(names);

    for (const key in data) {
      const itemData = data[key];
      const path = _.get(itemData, 'tableKey', '');
      result[key] = _.get(item, path, '');
    }

    return result;
  }

  getCurrentApplication() {
    return JSON.parse(sessionStorage.getItem('currentApplication'));
  }

  setCurrentWorkListDynamicSearch({ dynamicSearch, resource, associationItems}) {
    sessionStorage.setItem(SessionStorageService.CURRENT_WORKLIST_DYNAMIC_SEARCH,
      JSON.stringify({ dynamicSearch, resource, associationItems})
    );
  }
  getDuplicatePatientWarning(id) {
    const ordersMap = new Map(JSON.parse(sessionStorage.getItem('duplicatePatientWarning')));
    return ordersMap.get(id);
  }
  setDuplicatePatientWarning(id) {
    const ordersMap: any = new Map((JSON.parse(sessionStorage.getItem('duplicatePatientWarning'))));
    ordersMap.set(id, true);
    return sessionStorage.setItem('duplicatePatientWarning', JSON.stringify(ordersMap.toJSON()));
  }
  deleteDuplicatePatientWarning() {
    return sessionStorage.setItem('duplicatePatientWarning', '[]');
  }

  getdo() {
    return JSON.parse(sessionStorage.getItem('dignosticOrder'));
  }
  setdo(data) {
    return sessionStorage.setItem('dignosticOrder', JSON.stringify(data));
  }
  deletedo() {
    return sessionStorage.removeItem('dignosticOrder');
  }

}
